import React from "react";
import "./WorkGallery.css";
import ModernGrid from "./WorkGaleryGrids/ModernGrid";
import {MagneticCircleButton, SectionHeading3} from "..";

const Work = ({isButtonHide, projects}) => {
  return (
    <section className="section projects-section" id="projects">
      <div className="container">
        <SectionHeading3
          title="Let’s Explore Featured Projects"
          description="Discover a curated selection of our most impactful work. each project is a testament to our commitment to innovation, thoughtful design, and engineering excellence. These highlights reflect the diverse challenges we've tackled and the custom solutions we’ve crafted to drive results."
        />
      </div>
      <div className="gallery-grids-container">
        <ModernGrid projects={projects} />
        {isButtonHide && (
          <div className="more-button-div">
            <MagneticCircleButton text="Explore" text2="More" to="/projects" />
          </div>
        )}
      </div>
    </section>
  );
};

export default Work;
